// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3MXXh","imageUploader":"EGiftCard_imageUploader__CqJ5D"};